import { render } from "./FormPersonal.vue?vue&type=template&id=1694e7a6"
import script from "./FormPersonal.vue?vue&type=script&lang=js"
export * from "./FormPersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__